import { Subtitle1Styles } from '../../../typography';
import styled from 'styled-components';
import { getSizeBy, getColor, getColorShade } from '../../../../../src/styled/utils';
import { Button } from '../../../button';
import { MenuListItem } from '../../../menu';
export const PaginationWrapper = styled.ul `
  display: inline-grid;
  flex: 0 0 auto;
  grid-template-columns: 1fr 36px 36px;
  align-items: center;
  margin-right: ${getSizeBy(3)};
  column-gap: ${getSizeBy(3)};

  & :first-child {
    text-align: right;
  }
`;
export const PaginationCounter = styled.li `
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-size: ${getSizeBy(3)};
  line-height: ${getSizeBy(4)};
  letter-spacing: ${getSizeBy(0.04)};
`;
export const PaginationNavArrow = styled.li `
  & svg {
    color: ${({ disabled }) => disabled
    ? getColorShade('onSurface', 'outline')
    : getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
export const CounterButton = styled(Button) `
  background-color: transparent;
  border: none;

  & > span {
    ${Subtitle1Styles}
    color: ${getColorShade('onSurface', 'mediumEmphasis')};
    text-align: right;
    text-transform: none;
  }
`;
export const PaginationMenuItem = styled(MenuListItem) `
  display: flex;
  justify-content: space-between;
  width: ${getSizeBy(28.5)};

  & path {
    fill: ${getColor('primary')};
  }
`;
